import { createAction } from '@reduxjs/toolkit';

export const CHANGE_CANVAS_STATUS = 'CHANGE_CANVAS_STATUS';
export const CHANGE_LOGO_EDITING_STATUS = 'CHANGE_LOGO_EDITING_STATUS';
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export const SHOW_WAITING_COVER = 'SHOW_WAITING_COVER';
export const HIDE_WAITING_COVER = 'HIDE_WAITING_COVER';
export const SHOW_TRANSPARENCY_COVER = 'SHOW_TRANSPARENCY_COVER';
export const HIDE_TRANSPARENCY_COVER = 'HIDE_TRANSPARENCY_COVER';
export const SHOW_MESSAGE_BOX = 'SHOW_MESSAGE_BOX';
export const HIDE_MESSAGE_BOX = 'HIDE_MESSAGE_BOX';
export const INITIALIZE_PARAMETERS = 'INITIALIZE_PARAMETERS';
export const INITIALIZE_ITEMSPEC = 'INITIALIZE_ITEMSPEC';
export const CHANGE_WHATSNEXT_VISIBLE = 'CHANGE_WHATSNEXT_VISIBLE';
export const INITIALIZE_STEP1DATASTORE = 'INITIALIZE_STEP1DATASTORE';
export const INITIALIZE_PRICE = 'INITIALIZE_PRICE';
export const INITIALIZE_VENDOR = 'INITIALIZE_VENDOR';
export const INITIALIZE_ACTIVECART = 'INITIALIZE_ACTIVECART';
export const INITIALIZE_TEMPLATEPREVIEWDICT = 'INITIALIZE_TEMPLATEPREVIEWDICT';
export const INITIALIZE_QUESTIONS = 'INITIALIZE_QUESTIONS';
export const INITIALIZE_RELATIONS = 'INITIALIZE_RELATIONS';
export const INITIALIZE_UNIQUEOPTIONS = 'INITIALIZE_UNIQUEOPTIONS';
export const INITIALIZE_CHILDOPTIONS = 'INITIALIZE_CHILDOPTIONS';
export const ADDTOCART = 'ADDTOCART';
export const SET_CURRENTSTEP = 'SET_CURRENTSTEP';
export const SET_CURRENTIMPRINTAREAKEY = 'SET_CURRENTIMPRINTAREAKEY';
export const INITIALIZE_TRACKINGPIXELSCRIPT = 'INITIALIZE_TRACKINGPIXELSCRIPT';
export const INITIALIZE_BOMPREVIEW = 'INITIALIZE_BOMPREVIEW';
export const INITIALIZE_USER = 'INITIALIZE_USER';
export const ADD_TEMP_BACKGROUND_IMAGE = 'ADD_TEMP_BACKGROUND_IMAGE';
export const REMOVE_TEMP_BACKGROUND_IMAGE = 'REMOVE_TEMP_BACKGROUND_IMAGE';
export const UPDATE_TEMP_BACKGROUND_IMAGE = 'UPDATE_TEMP_BACKGROUND_IMAGE';
export const SET_PROP65MESSAGE_ONEOFF = 'SET_PROP65MESSAGE_ONEOFF';
export const TOKENWARNING_POPUP_TOGGLE = 'TOKENWARNING_POPUP_TOGGLE';
export const TOKENEXPIRATION_POPUP_TOGGLE = 'TOKENEXPIRATION_POPUP_TOGGLE';
export const CHANGE_INITIALIZEDIMPRINTAREAKEYS = 'CHANGE_INITIALIZEDIMPRINTAREAKEYS';
export const INITIALIZE_SAVEPROJECT = 'INITIALIZE_SAVEPROJECT';
export const INITIALIZE_CHARGES = 'INITIALIZE_CHARGES';
export const INITIALIZE_CHARGEDETAILS = 'INITIALIZE_CHARGEDETAILS';
export const SET_ELEMENT_DRAG_FLAG = 'SET_ELEMENT_DRAG_FLAG';
export const TOGGLE_BATCH_SELECT_FLAG_FOR_TOUCH = 'TOGGLE_BATCH_SELECT_FLAG_FOR_TOUCH';
export const SWITCH_SHOWVIEWPRICINGPANEL = 'SWITCH_SHOWVIEWPRICINGPANEL';
export const SET_BEFORE_UNLOAD_LISTEN = 'SET_BEFORE_UNLOAD_LISTEN';
export const SET_PARAMETER_TOKEN = 'SET_PARAMETER_TOKEN';
export const INITIALIZE_ORDER = 'INITIALIZE_ORDER';
export const INITIALIZE_SHIPPING = 'INITIALIZE_SHIPPING';
export const UPDATE_SHIPPING = 'UPDATE_SHIPPING';
const INITIALIZE_IMPRINTAREA_DIMENSION = 'INITIALIZE_IMPRINTAREA_DIMENSION';
const INITIALIZE_SPECIALSYMBOLS = 'INITIALIZE_SPECIALSYMBOLS';
export const CHANGE_IMPRINTAREA_DIMENSION = 'CHANGE_IMPRINTAREA_DIMENSION';
export const CHANGE_SCALE = 'CHANGE_SCALE';
export const CHANGE_HEIGHTFITS = 'CHANGE_HEIGHTFITS';
export const FIRST_SHIFT_TAB = 'FIRST_SHIFT_TAB';
export const HAS_INVALID_CHARACTER = 'HAS_INVALID_CHARACTER';
export const IS_TEXT_COLOR_EDITING = 'IS_TEXT_COLOR_EDITING';
export const SHOW_APPLY_TO_ALL_BUTTON = 'SHOW_APPLY_TO_ALL_BUTTON';
export const SET_CURRENT_IMPRINT_OPTION_STEP = 'SET_CURRENT_IMPRINT_OPTION_STEP';
export const SET_NEW_UPLOAD_LOGO_FLAG = 'SET_NEW_UPLOAD_LOGO_FLAG';
export const ASK_IF_USER_NEED_IMPRINT_TEXT = 'ASK_IF_USER_NEED_IMPRINT_TEXT';
export const SET_NEED_IMPRINT_OPTION_MODE = 'SET_NEED_IMPRINT_OPTION_MODE';
export const SET_CURRENT_ASK_NEED_IMPRINT_OPTION_INFO = 'SET_CURRENT_ASK_NEED_IMPRINT_OPTION_INFO';
export const BACKUP_STOCK_IMAGE_TYPE = 'BACKUP_STOCK_IMAGE_TYPE';
export const ADD_BACKUPS_FOR_LITE_PARENT_CHILD_ITEM = 'ADD_BACKUPS_FOR_LITE_PARENT_CHILD_ITEM';
export const IMPRINT_OPTION_UI_SET = 'IMPRINT_OPTION_UI_SET';
export const SET_IMPRINT_GROUPS = 'SET_IMPRINT_GROUPS';
export const IMPRINT_OPTION_UI_INITIALIZE = 'IMPRINT_OPTION_UI_INITIALIZE';
export const SET_TOP_PADDING_HEIGHT_OF_IMPRINT_VIEW = 'SET_TOP_PADDING_HEIGHT_OF_IMPRINT_VIEW';
export const SET_REGISTER_FOR_EMAIL_UPDATES = 'SET_REGISTER_FOR_EMAIL_UPDATES';
export const SWITCH_SHOW_WARNING_MESSAGE_CONTAINER = 'SWITCH_SHOW_WARNING_MESSAGE_CONTAINER';
export const IS_VALID_RETURNURL = 'IS_VALID_RETURNURL';
export const INITIALIZE_CART_NEW_FXG = 'INITIALIZE_CART_NEW_FXG';
export const INITIALIZE_DETAIL_INFO = 'INITIALIZE_DETAIL_INFO';
export const SET_CANVAS_PREVIEW = 'ui/setCanvasPreview';
export const SHOW_CONFIRM_DIALOG = 'SHOW_CONFIRM_DIALOG';
export const HIDE_CONFIRM_DIALOG = 'HIDE_CONFIRM_DIALOG';

export const initializeCartUseScene7Template = createAction('INITIALIZE_CART_NEW_FXG');
export const showWaitingCover = createAction('SHOW_WAITING_COVER');
export const hideWaitingCover = createAction('HIDE_WAITING_COVER');
export const showTransparencyCover = createAction('SHOW_TRANSPARENCY_COVER');
export const hideTransparencyCover = createAction('HIDE_TRANSPARENCY_COVER');
export const showMessageBox = createAction('SHOW_MESSAGE_BOX');
export const showConfirmDialog = createAction(SHOW_CONFIRM_DIALOG);
export const hideMessageBox = createAction('HIDE_MESSAGE_BOX');
export const hideConfirmDialog = createAction(HIDE_CONFIRM_DIALOG); 
export const initializeParameters = createAction(INITIALIZE_PARAMETERS);
export const setParameterToken = createAction(SET_PARAMETER_TOKEN);
export const initializeItemSpec = createAction(INITIALIZE_ITEMSPEC);
export const initializeVendor = createAction(INITIALIZE_VENDOR);
export const initializeActiveCart = createAction(INITIALIZE_ACTIVECART);
export const initializeTemplatePreviewDict = createAction(INITIALIZE_TEMPLATEPREVIEWDICT);
export const setCurrentStep = createAction(SET_CURRENTSTEP);
export const setCurrentImprintAreaKey = createAction(SET_CURRENTIMPRINTAREAKEY);
export const initializeTrackingPixelScript = createAction(INITIALIZE_TRACKINGPIXELSCRIPT);
export const initializeBomPreview = createAction(INITIALIZE_BOMPREVIEW);
export const initializeUser = createAction(INITIALIZE_USER);
export const changeInitializedImprintAreaKeys = createAction(CHANGE_INITIALIZEDIMPRINTAREAKEYS);
export const initializeSaveProject = createAction(INITIALIZE_SAVEPROJECT);
export const updateSaveProject = createAction('updateSaveProject');
export const initializeCharges = createAction(INITIALIZE_CHARGES);
export const switchShowViewPricingPanel = createAction(SWITCH_SHOWVIEWPRICINGPANEL);
export const changeLogoEditingStatus = createAction(CHANGE_LOGO_EDITING_STATUS);
export const changeCanvasStatus = createAction(CHANGE_CANVAS_STATUS);
export const vendorInit = createAction('VENDOR_INIT');
export const updateWaitingCover = createAction(SET_UPLOAD_PROGRESS);
export const setProp65MessageOneOff = createAction(SET_PROP65MESSAGE_ONEOFF);
export const addTempBackgroundImage = createAction(ADD_TEMP_BACKGROUND_IMAGE);
export const removeTempBackgroundImage = createAction(REMOVE_TEMP_BACKGROUND_IMAGE);
export const updateTempBackgroundImage = createAction(UPDATE_TEMP_BACKGROUND_IMAGE);
export const tokenWarningPopupToggle = createAction(TOKENWARNING_POPUP_TOGGLE);
export const tokenExpirationPopupToggle = createAction(TOKENEXPIRATION_POPUP_TOGGLE);
export const setElementDragFlag = createAction(SET_ELEMENT_DRAG_FLAG);
export const toggleBatchSelectFlagForTouch = createAction(TOGGLE_BATCH_SELECT_FLAG_FOR_TOUCH);
export const updateReturningUrl = createAction('updateReturningUrl');
export const setBeforeUnloadListen = createAction(SET_BEFORE_UNLOAD_LISTEN);
export const initializeImprintAreaDimension = createAction(INITIALIZE_IMPRINTAREA_DIMENSION);
export const initializeSpecialSymbols = createAction(INITIALIZE_SPECIALSYMBOLS);
export const changeImprintAreaDimension = createAction(CHANGE_IMPRINTAREA_DIMENSION);
export const changeScale = createAction(CHANGE_SCALE);
export const changeHeightFits = createAction(CHANGE_HEIGHTFITS);
export const firstShiftTab = createAction(FIRST_SHIFT_TAB);
export const hasInvalidCharacter = createAction(HAS_INVALID_CHARACTER);
export const isTextColorEditing = createAction(IS_TEXT_COLOR_EDITING);
export const showApplyToAllButton = createAction(SHOW_APPLY_TO_ALL_BUTTON);
export const isValidReturnUrl = createAction(IS_VALID_RETURNURL);
export const initializeOrder = createAction(INITIALIZE_ORDER);
export const initializeShipping = createAction(INITIALIZE_SHIPPING);
export const updateShipping = createAction(UPDATE_SHIPPING);
export const saveZipCode = createAction('parameters/saveZipCode');
export const setCurrentImprintOptionStep = createAction(SET_CURRENT_IMPRINT_OPTION_STEP);
export const imprintOptionUISet = createAction(IMPRINT_OPTION_UI_SET);
export const imprintOptionUIInitialize = createAction(IMPRINT_OPTION_UI_INITIALIZE);
export const setGuideMode = createAction('SET_GUIDE_MODE');
export const setNewUploadLogoFlag = createAction(SET_NEW_UPLOAD_LOGO_FLAG);
export const backupLogoDataBeforeCrop = createAction('BACKUP_LOGO_DATA_BEFORE_CROP');
export const askIfUserNeedImprintText = createAction(ASK_IF_USER_NEED_IMPRINT_TEXT);
export const setTopPaddingHeightOfImprintView = createAction(SET_TOP_PADDING_HEIGHT_OF_IMPRINT_VIEW);
export const saveProjectData = createAction('SAVE_PROJECT_DATA');
export const setNeedImprintOptionMode = createAction(SET_NEED_IMPRINT_OPTION_MODE);
export const setCurrentAskNeedImprintOptionInfo = createAction(SET_CURRENT_ASK_NEED_IMPRINT_OPTION_INFO);
export const switchShowWarningMessageContainer = createAction(SWITCH_SHOW_WARNING_MESSAGE_CONTAINER);
export const setAllDataLoadedForLite = createAction('ui/setAllDataLoadedForLite');
export const backupStockImageType = createAction(BACKUP_STOCK_IMAGE_TYPE);
export const setRegisterForEmailUpdates = createAction(SET_REGISTER_FOR_EMAIL_UPDATES);
export const addBackupsForLiteParentChildItem = createAction(ADD_BACKUPS_FOR_LITE_PARENT_CHILD_ITEM);
export const setPrevLiteSharedArtDict = createAction('ui/setPrevLiteSharedArtDict');
export const setPrevLiteSharedArtColorsDict = createAction('ui/setPrevLiteSharedArtColorsDict');
export const setExternalWaitingCoverId = createAction('ui/setExternalWaitingCoverId');
export const initializeNavInkPreconfigurationParameters = createAction(
  'parameters/initializeNavInkPreconfigurationParameters'
);
export const setCanvasPreview = createAction(SET_CANVAS_PREVIEW);
export const sendOfflineChatMessage = createAction('SEND_OFFLINE_CHAT_MESSAGE');
export const initialOfflineChatBox = createAction('INIT_OFFLINE_CHAT_BOX');
export const finishOfflineChat = createAction('FINISH_OFFLINE_CHAT');
export const sendOfflineChatError = createAction('SEND_OFFLINE_CHAT_ERROR');
export const setOfflineChatLoading = createAction('SET_OFFLINE_CHAT_LOADING');
export const initializeDetailInfo = createAction('INITIALIZE_DETAIL_INFO');
//---imprint actions
export const setImprintGroups = createAction(SET_IMPRINT_GROUPS);
export const setGroupSelectedRule = createAction('SET_GROUP_SELECTED_RULE');
export const skipGroupRuleSelect = createAction('SKIP_GROUP_RULE_SELECT');
